import { type CheckoutTransaction, getCheckoutTransaction } from 'models';
import { useMutation } from 'query';
import { checkoutTransaction } from '../../services';

type RecordGiftByCheck = {
  id: string;
  pathname: string;
};

export const useCheckoutTransaction = () =>
  useMutation<CheckoutTransaction, RecordGiftByCheck>({
    async mutationFn({ id, pathname }) {
      const { data } = await checkoutTransaction({
        /* eslint-disable @typescript-eslint/naming-convention -- Start: required by backend API */
        body: {
          redirect_path: pathname,
        },
        routeParams: {
          id,
        },
        /* eslint-enable @typescript-eslint/naming-convention -- End: required by backend API */
      });

      return getCheckoutTransaction(data);
    },
  });
